module.exports = __webpack_public_path__ + "pattern-2.dc74d0fc4cd1d55ea866.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/images/patterns/pattern-2.png
// module id = ../../../../../src/assets/images/patterns/pattern-2.png
// module chunks = styles